import React, { useState } from 'react';
import { getImageUrl } from '../../utils/imageUrl';

/**
 * AppImage Component
 *
 * A centralized image component that handles:
 * - Automatic URL resolution (Local vs Cloud storage)
 * - Lazy loading for performance
 * - Error handling with fallback image
 *
 * @example
 * // Basic usage
 * <AppImage src={entity.logo_url} alt="Logo" />
 *
 * @example
 * // With custom fallback
 * <AppImage src={vehicle.picture_url} alt="Vehicle" fallbackSrc="/images/vehicle-placeholder.png" />
 *
 * @example
 * // Without fallback (renders nothing on error)
 * <AppImage src={user.avatar_url} alt="Avatar" fallbackSrc={null} />
 */
const AppImage = ({ src, alt, fallbackSrc = '/images/placeholder.svg', ...props }) => {
  const [error, setError] = useState(false);
  const finalSrc = getImageUrl(src);

  // If no source or error occurred, show fallback or nothing
  if (!finalSrc || error) {
    // Return fallback image if provided, otherwise null
    return fallbackSrc ? (
      <img
        src={fallbackSrc}
        alt={alt}
        loading="lazy"
        {...props}
      />
    ) : null;
  }

  return (
    <img
      src={finalSrc}
      alt={alt}
      loading="lazy"
      onError={() => setError(true)}
      {...props}
    />
  );
};

export default AppImage;
